import * as React from 'react';
import { hydrateRoot } from 'react-dom/client';

import { createContext } from './createContext';
import { openEventChannel } from '../../../shared/actions/socket';
import { AppContainer } from '../../../shared/containers/App';
import { attachReducers } from '../../../shared/reducers/attachReducers';
import { createAppStore } from '../../../shared/store/createAppStore';
import { TAppState } from '../../../shared/types/appState';
import { TReduxActions } from '../../../shared/types/redux/actions';
import { attachSocketToContext } from '../../utils/attachSocketToContext';
import { selectIsUserAuthenticated } from '../../../shared/selectors';

export function runApp() {
  const context = createContext();
  const { config } = context;

  const initialState = config.getStrict<TAppState>('initialState');
  const dispatchActions = config.get<TReduxActions[]>('dispatchActions');

  attachSocketToContext(context);

  const store = createAppStore({
    initialState,
    optionalParams: {
      dispatchReducerAddedAction: true,
      dispatchRunnerSagaAction: true,
    },
    context,
  });

  attachReducers(store);

  const rootElement = document.getElementById('frontend-chats');

  if (!rootElement) {
    throw new Error('Unable to find element #frontend-chats');
  }

  const state = store.getState();
  const isUserAuthenticated = selectIsUserAuthenticated(state);

  if (isUserAuthenticated) {
    store.dispatch(openEventChannel());
  }

  if (dispatchActions && dispatchActions.length) {
    dispatchActions.forEach(action => store.dispatch(action));
  }

  hydrateRoot(rootElement, <AppContainer store={store} context={context} />);
}
